import React from 'react';
import ReactStars from 'react-stars';
import { useTimer } from 'react-timer-hook';
import { useSelector } from 'react-redux';
import Tag from '../UI/Tag';
import ModalSendMessage from './ProductModals/ModalSendMessage';
import ModalReportProduct from './ProductModals/ModalReportProduct';
import CustomLink from '../UI/CustomLink';
import IconUser from '../UI/Icons/IconUser';
import IconStar from '../UI/Icons/IconStar';
import IconList from '../UI/Icons/IconList';
import Modal from '../UI/Modal';
import helpers from '../../helpers/helpers';
//import Icon from '../UI/Icon';

const ProductData = ({
  currentProduct,
  userClickOnTagHandler,
  onPurchase,
  quantity,
  quantityHandle,
  bid,
  bidHandle,
}) => {
  const { token } = useSelector((state) => state.auth);
  const { creating, creatingSuccess } = useSelector((state) => state.order);
  const { user } = useSelector((state) => state.auth);
  const { balancesList } = useSelector((state) => state.balances);
  const {
    days: daysEnd, hours: hoursEnd, minutes: minutesEnd, seconds: secondsEnd,
  } = useTimer({ expiryTimestamp: new Date(currentProduct.auction_info.data_end) });
  const {
    days: daysStart, hours: hoursStart, minutes: minutesStart, seconds: secondsStart,
  } = useTimer({ expiryTimestamp: new Date(currentProduct.auction_info.data_start) });

  const { getTranslationText } = helpers;

  const quantHandlMinus = () => {
    if (quantity - 1 > 0) {
      quantityHandle(quantity - 1);
    }
  };

  const quantHandlPlus = () => {
    if (quantity + 1 <= currentProduct.quantity) {
      quantityHandle(quantity + 1);
    }
  };

  const quantInputHandl = (num) => {
    if (num > currentProduct.quantity) {
      quantityHandle(currentProduct.quantity);
    } else if (num < 1) {
      quantityHandle(1);
    } else {
      quantityHandle(num);
    }
  };

  const getPrice = () => {
    if (currentProduct.type === 0) {
      // eslint-disable-next-line max-len
      return quantity > 1 ? quantity * currentProduct?.price?.price : currentProduct?.price?.price;
    } if (currentProduct.type === 10) {
      if (currentProduct.auction_bids?.filter((el) => el.active)[0]?.bid) {
        return currentProduct.auction_bids?.filter((el) => el.active)[0].bid;
      }
      return currentProduct?.price?.price;
    }

    return null;
  };

  return (
    <div className="product__data">
      {/*<div>*/}
      {/*  <div className="product__data__views">*/}
      {/*    {currentProduct.visits}*/}
      {/*    {' '}*/}
      {/*    <Icon type="eye" />*/}
      {/*  </div>*/}
      {/*</div>*/}
      <h1 className="product__data__title">{currentProduct.title}</h1>
      <div className="product__data__container">
        <div className="product__data__controls">
          <div className="product__data__controls__line user">
            <span>
              {currentProduct.user.avatar
                ? <div style={{ backgroundImage: `url(${currentProduct.user.avatar})`, backgroundColor: 'red' }} className="avatar" />
                : <IconUser color="#636171" /> }
            </span>
            <div>
              <p>{currentProduct.user && currentProduct.user.username}</p>
              <div className="stars">
                <ReactStars
                  count={5}
                  size={16}
                  color2="#ffd700"
                  value={currentProduct.user && currentProduct.user.rating}
                  edit={false}
                />
                {' '}
                <span>{currentProduct.user && currentProduct.user.rating}</span>
              </div>
            </div>
          </div>
          <CustomLink href="/[username]" as={`/${currentProduct?.user?.username}`}>
            <div className="product__data__controls__line ">
              <span><IconStar color="#636171" /></span>
              <p>{getTranslationText('product.about_shop')}</p>
            </div>
          </CustomLink>
          <ModalSendMessage productId={currentProduct?.id} token={token} />
          <CustomLink href="/search[...params]" as={`/search?u=${currentProduct?.user?.username}`}>
            <div className="product__data__controls__line ">

              <span><IconList color="#636171" /></span>
              <p>{getTranslationText('product.all_products')}</p>

            </div>
          </CustomLink>
          <ModalReportProduct productId={currentProduct.id} token={token} />
        </div>
        <div className="product__data__action">
          <div className="tags">
            {currentProduct.tags && currentProduct.tags.map((tag) => (
              <Tag
                key={`${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`}
                value={tag.tag}
                userClickOnTagHandler={userClickOnTagHandler}
              />
            ))}
          </div>

          <div className="product__price__wrapper">
            {!!currentProduct?.auction_bids?.length && <div>{`${getTranslationText('product.last_bid')}:`}</div>}
            <div className="product__price">
              <div>
                {
                  getPrice()
                }
              </div>
              {' '}
              <span>
                {currentProduct?.price?.name}
              </span>
            </div>
            {(currentProduct.quantity > 1 && currentProduct.type === 0)
            && (
            <div className="product__quantity__wrapper">
              <label>{`Max num. ${currentProduct.quantity}`}</label>
              <div className="product__quantity">
                <div className="arrow" onClick={quantHandlMinus}><div className="arrow-left" /></div>
                <input type="text" value={quantity} onChange={(e) => quantInputHandl(Number(e.target.value))} />
                <div className="arrow" onClick={quantHandlPlus}><div className="arrow-right" /></div>
              </div>
            </div>
            )}
            <div className="product__blockchain_link">
              <a href={currentProduct.url_decimal_explorer} rel="noreferrer" target="_blank">
                Blockchain explorer
              </a>
            </div>
            {/*<div className="product__price__options">
              {
                currentProduct.price.length > 1
                && <div className="title">Так же вы можете купить продукт в других валютах:</div>
              }
              {
                currentProduct.price.filter((priceItem) => priceItem.name !== defaultPrice.name)
                  .map((price) => (
                    <div
                      className="option-item"
                      onClick={() => setDefaultPrice(price)}
                    >
                      {getPrice(price)}
                      {' '}
                      {price.name}
                    </div>
                  ))
              }
            </div>*/}
            {currentProduct.type === 10 && (
              !daysStart && !hoursStart && !minutesStart && !secondsStart
                ? (
                  <>
                    <div className="auction-timer-text">{`${getTranslationText('product.auction_ends')}:`}</div>
                    <div className="auction-timer">
                      {`${daysEnd}d: ${Number(hoursEnd) < 10
                        ? `0${hoursEnd}` : hoursEnd}h: ${Number(minutesEnd) < 10 ? `0${minutesEnd}` : minutesEnd}m: 
                        ${Number(secondsEnd) < 10 ? `0${secondsEnd}` : secondsEnd}s`}
                    </div>
                  </>
                )
                : (
                  <>
                    <div className="auction-timer-text">{`${getTranslationText('product.auction_start')}:`}</div>
                    <div className="auction-timer">
                      {`${daysStart}d: ${Number(hoursStart) < 10
                        ? `0${hoursStart}` : hoursStart}h: ${Number(minutesStart) < 10 ? `0${minutesStart}` : minutesStart}m: 
                        ${Number(secondsStart) < 10 ? `0${secondsStart}` : secondsStart}s`}
                    </div>
                  </>
                )
            )}
          </div>
          <Modal
            modalTitle={getTranslationText('product.purchase_product')}
            modalTrigger={(
              <button
                type="button"
                disabled={!token
                || currentProduct?.user?.id === user?.id
                || (currentProduct.type === 10 && !currentProduct.auction_info.active)
                || balancesList.length >= 1 && balancesList.filter((el) => Number(el?.balance) < getPrice() && el?.currency === "del" ).length >= 1
                || currentProduct.type === 10 && !daysEnd && !hoursEnd && !minutesEnd && !secondsEnd
                }
                title={token ? getTranslationText('product.purchase') : getTranslationText('product.login_to_buy')}
              >
                { currentProduct.type !== 10 ? getTranslationText('product.purchase') : getTranslationText('product.make_bid')}
              </button>
              )}
            onSubmitLabel={getTranslationText('product.open_deal')}
            onCancelLabel={getTranslationText('deals.cancel')}
            onSubmit={onPurchase}
            buttonDisabled={creating
            || !token
            || currentProduct?.user?.id === user?.id
            || (currentProduct.type === 10
                && currentProduct.auction_bids?.length
                // eslint-disable-next-line max-len
                && (bid - Number(currentProduct.auction_bids?.filter((el) => el.active)[0].bid) < 0.00001))
            || (currentProduct.type === 10
                && !currentProduct.auction_bids?.length
                // eslint-disable-next-line max-len
                && (bid < Number(currentProduct?.price.price)))
            || (currentProduct.type === 10 && !currentProduct.auction_info.active)
            || balancesList.length >= 1 && balancesList.filter((el) => Number(el?.balance) < getPrice() && el?.currency === "del" ).length >= 1
            || currentProduct.type === 10 && !daysEnd && !hoursEnd && !minutesEnd && !secondsEnd
            }
            sendSuccess={creatingSuccess}
          >

            {currentProduct.type === 10 && (
            <>
              <div className="form-field bid-input">
                <label>{getTranslationText('product.sum_to_bid')}</label>
                <input type="number" onChange={(e) => bidHandle(Number(e.target.value))} />
              </div>
            </>
            )}
            <div>{ !currentProduct.type ? getTranslationText('product.sure_to_deal') : getTranslationText('product.sure_to_bid')}</div>
            <div>{ !currentProduct.type ? getTranslationText('product.amount_frozen') : getTranslationText('product.bid_frozen')}</div>

          </Modal>
          {
            !token && <div className="product__login-warning">{getTranslationText('product.login_to_buy')}</div>
          }
          {
            currentProduct?.user?.id === user?.id
            // eslint-disable-next-line react/no-unescaped-entities
            && <div className="product__login-warning">{getTranslationText('product.cant_buy_prod')}</div>
          }
          {
            currentProduct.type === 10 && !daysEnd && !hoursEnd && !minutesEnd && !secondsEnd && (
                <div className="product__login-warning">{currentProduct?.auction_bids?.length
                    ? `${getTranslationText('product.nft_won_by')} ${currentProduct.auction_bids[0]?.creator.username}`
                    : getTranslationText('product.nft_is_disabled')
                  }
                </div>
            )
          }
          {
            !!balancesList.length >= 1 && balancesList.filter((el) => Number(el?.balance) < getPrice() && el?.currency === "del" ).length >= 1 && (
                <div className="product__login-warning">{getTranslationText('product.not_enough_money')}</div>
            )
          }
          {currentProduct.auction_info.active && (
          <>
            {!!currentProduct?.auction_bids?.length && <div className="product__bids-name">{`${getTranslationText('product.last_bids')}:`}</div>}
            <div className="product__bids-wrapper">
              {
              !!currentProduct?.auction_bids?.length
              && currentProduct.auction_bids?.map((el) => (
                <div key={el.bid} className="product__bid-item">
                  <div className="bid-info">
                    <div>{`${getTranslationText('product.bid_by')} ${el.creator.username}`}</div>
                    <div>{`${el.bid} ${currentProduct?.price.name}`}</div>
                  </div>
                  <div className="bid-date">{helpers.parseDate(el.created)}</div>
                </div>
              ))
            }
            </div>
          </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductData;
